import { ReactNode, lazy, Suspense } from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { DeferredIdle } from "@/components/DeferredIdle";


// Toaster is only needed once the user triggers a toast — defer the sonner
// bundle off the critical hydration path.
const Toaster = lazy(() =>
  import("sonner").then((m) => ({ default: m.Toaster })),
);

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
      <DeferredIdle>
        <Suspense fallback={null}>
          <Toaster theme="dark" position="top-center" />
        </Suspense>
        
      </DeferredIdle>
    </div>
  );
}
